import { BiCheck } from 'react-icons/bi';
import { MdDeleteForever } from 'react-icons/md';
import { Avatar } from '../../../../../../../components/avatar/avatar';
import { ExtendableBlock } from '../../../../../../../components/extendable-block/extendable-block';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { TimePicker } from '../../../../../../../features/date-time/time-picker/time-picker';
import s from './shifts-grid-shift-employee-modal.module.css';
import { useShiftsGridEmployeeModal } from './use-shifts-grid-shift-employee-modal';

export const ShiftsGridShiftEmployeeModal = (props: ModalProps) => {
  const {
    t,
    employeeName,
    handleDelete,
    handleSave,
    isLoading,
    handleAdd,
    updatedShifts,
    handleUpdate,
    label,
  } = useShiftsGridEmployeeModal(props);

  return (
    <Modal {...props} title={label} className={s.feature}>
      <div className={s.employee}>
        <Avatar name={employeeName} />
        {employeeName}
      </div>
      <div className={s.schedule}>
        <h3>{t('Рабочее расписание')}</h3>
        <ExtendableBlock
          button={updatedShifts.length ? undefined : { children: t('Добавить') }}
          onAdd={handleAdd}
        >
          {updatedShifts.map((shift, index) => (
            <div className={s.range} key={index}>
              <TimePicker
                className={s.timePicker}
                placeholder={t('Начало')}
                value={shift.from}
                name={`from-${index}`}
                onChange={(e) => handleUpdate(String(shift.id || index), 'from', e)}
              />
              <TimePicker
                className={s.timePicker}
                placeholder={t('Завершение')}
                value={shift.to}
                name={`to-${index}`}
                onChange={(e) => handleUpdate(String(shift.id || index), 'to', e)}
              />
              <IconButton
                variant="danger"
                onClick={() => handleDelete(String(shift.id || index))}
                disabled={isLoading}
              >
                <MdDeleteForever />
              </IconButton>
            </div>
          ))}
        </ExtendableBlock>

        <div className={s.controls}>
          <IconButton onClick={handleSave} disabled={isLoading}>
            <BiCheck />
          </IconButton>
        </div>
      </div>
    </Modal>
  );
};
